__turbopack_context__.v({
  "panelWrapper": "tabModuleMobile-module-scss-module__TlUxSq__panelWrapper",
  "swiperSlideItem": "tabModuleMobile-module-scss-module__TlUxSq__swiperSlideItem",
  "tabsContent": "tabModuleMobile-module-scss-module__TlUxSq__tabsContent",
});
